<template>
  <div v-if="goods.length" v-loading="loading" class="recommended-products width_center_1200">
    <div class="head">
      <h3>{{ lang.Recommended_products }}</h3>
      <router-link to="/goods/list">{{ lang.more }}</router-link>
    </div>
    <ul class="goods-list">
      <li v-for="item in goods" :key="item.id">
        <goods :item="item"></goods>
      </li>
    </ul>
  </div>
</template>

<script>
import { getproductlist } from '@/api/product'
import goods from '@/components/ShopGoods/index'
export default {
  components: { goods },
  computed: {
    lang() {
      return this.$t('goods')
    }
  },
  data() {
    return {
      goods: [],
      loading: false
    }
  },
  methods: {
    getList() {
      this.loading = true
      getproductlist({
        name: '',
        type: '',
        pageNum: 1,
        pageSize: 8
      }).then(({ data }) => {
        this.loading = false
        this.goods = data.data.map((item) => {
          return {
            title: item.mercName,
            ...item
          }
        })
      })
    }
  },
  async created() {
    this.getList()
  }
}
</script>
<style lang="scss" scoped>
.recommended-products {
  width: 1200px;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    h3 {
      font-size: 18px;
      color: #000;
    }
    a {
      color: #4f4f4f;
      font-size: 12px;
    }
  }
  .goods-list {
    width: 110%;
    li {
      float: left;
      box-sizing: border-box;
      margin-right: 16px;
      margin-bottom: 16px;
      width: 288px;
      height: 110px;
    }
  }
}
</style>